<div class="o-grid o-grid--wrap">
	<div class="o-grid__cell o-grid__cell--w-100">
		<div class="c-card">
			<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/bg-support.png" style="width:360px;margin: 0px auto;"/>
			<div>
				<p class="c-section__title--sm" style="text-align:center;">{{ 'Siffi.Services_Mental_Health_Unavailable' | translate }}</p>
			</div>
			<div class="c-content" *ngIf="!vm.weekendStartTimeInHours && !vm.weekendEndTimeInHours">
				<p class="c-header__subheading" style="text-align:center;">{{ ('Siffi.Services_Intro_4' | translate).replace("%s", vm.startTimeInHours).replace("%e", vm.endTimeInHours) }}</p>
			</div>
			<div class="c-content" *ngIf="vm.weekendStartTimeInHours && vm.weekendEndTimeInHours">
				<p class="c-header__subheading" style="text-align:center;">{{ ('Siffi.Services_Intro_4_Weekends' | translate).replace("%s", vm.startTimeInHours).replace("%e", vm.endTimeInHours).replace("%ws", vm.weekendStartTimeInHours).replace("%we", vm.weekendEndTimeInHours) }}</p>
			</div>
			<div class="c-content u-osb-lg">
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--w-100 u-no-p" style="text-align:center;">
						<a href="" class="c-button c-button--md c-button--s2 c-button--fixed">{{ 'Common.Back' | translate }}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
